import React from 'react';
import { Drawer, Empty, Spin } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { getTasks, PlannerPage } from '../../../services/tasks';
import { taskReference } from '../../../utils/publicReferences';
import TaskCard from './TaskCard';

interface BacklogPanelProps {
  plannerPage: PlannerPage;
  open: boolean;
  onClose: () => void;
  onTaskMove?: (taskId: string, newStatus: string) => void;
  onTaskOpen?: (taskId: string) => void;
}

const BacklogPanel: React.FC<BacklogPanelProps> = ({ plannerPage, open, onClose, onTaskOpen }) => {
  const { data: tasks = [], isLoading } = useQuery({
    queryKey: ['tasks', plannerPage.id, 'backlog'],
    queryFn: () => getTasks({ 
      plannerPageId: plannerPage.id,
      status: 'backlog', // Assuming backlog is a status
    }),
    enabled: open,
  });

  const backlogTasks = tasks.filter(task => 
    !plannerPage.statuses.includes(task.status) || task.status === 'backlog'
  );

  return (
    <Drawer
      title="Backlog"
      placement="right"
      width={400}
      onClose={onClose}
      open={open}
    >
      {isLoading ? (
        <Spin size="large" style={{ display: 'block', textAlign: 'center', padding: '40px' }} />
      ) : backlogTasks.length === 0 ? (
        <Empty
          description="No tasks in backlog"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          style={{ padding: '40px 0', color: '#BFBFBF' }}
        />
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {backlogTasks.map((task) => (
            <TaskCard
              key={task.id}
              task={task}
              onClick={() => onTaskOpen?.(taskReference(task))}
            />
          ))}
        </div>
      )}
    </Drawer>
  );
};

export default BacklogPanel;
